export const UpsWalletService = Object.freeze({
  Ground: '10301',
  GroundSaver: '10391',
  ThreeDaySelect: '10350',
  NextDayAirSaver: '10305',
  NextDayAir: '10306',
  SecondDayAir: '10303',
});
